<template>
  <div class="w-screen bg-white">
    <div
      :style="{
        'background-image':
          'url(' + require('../assets/images/background_kiosk.png') + ')',
      }"
      class="w-screen h-screen bg-cover"
    >
      <img class="w-screen kioskFotoScreen" />
    </div>
    <div class="">
      ezoifezi
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
